import { portalSocket } from "./portalSocket"

class SeempSocket2 {
	readonly onSeempActionResult = portalSocket.addEventSource("seempActionResult")
	readonly onSeempActionResultProgress = portalSocket.addEventSource("seempActionResultProgress")
}

export const seempSocket2 = new SeempSocket2()
